{
  "Accessibility Menu": "Menyu ya Ufikiaji",
  "Reset settings": "Weka upya mipangilio",
  "Close": "Funga",
  "Content Adjustments": "Marekebisho ya Maudhui",
  "Adjust Font Size": "Rekebisha Ukubwa wa Herufi",
  "Highlight Title": "Angazia Kichwa",
  "Highlight Links": "Angazia Viungo",
  "Readable Font": "Herufi Inayosomeka",
  "Color Adjustments": "Marekebisho ya Rangi",
  "Dark Contrast": "Tofauti ya Giza",
  "Light Contrast": "Tofauti ya Mwanga",
  "High Contrast": "Tofauti ya Juu",
  "High Saturation": "Usitishaji wa Juu",
  "Low Saturation": "Usitishaji wa Chini",
  "Monochrome": "Monokromu",
  "Tools": "Vifaa",
  "Reading Guide": "Mwongozo wa Kusoma",
  "Stop Animations": "Simamisha Uhuishaji",
  "Big Cursor": "Kisahihi Kikubwa",
  "Increase Font Size": "Ongeza Ukubwa wa Herufi",
  "Decrease Font Size": "Punguza Ukubwa wa Herufi",
  "Letter Spacing": "Nafasi ya Herufi",
  "Line Height": "Urefu wa Mstari",
  "Font Weight": "Uzito wa Herufi",
  "Dyslexia Font": "Herufi ya Dyslexia",
  "Language": "Lugha",
  "Open Accessibility Menu": "Fungua Menyu ya Ufikiaji"
}
